import * as React from 'react';
import { ConnectedSearchResultPage } from '../../search/components/SearchResultPage';

export interface MainOwnProps {
  routeLocationSearch: string;
  routeLocationPathName: string;
}

export type MainProps = MainOwnProps;

export function Main(props: MainProps): JSX.Element {
  return <ConnectedSearchResultPage routeLocationSearch={props.routeLocationSearch} routeLocationPathName={props.routeLocationPathName} />;
}
